import React, { useEffect, Fragment, useState } from "react";
import Breadcrumb from "../DefaultComponent/BreadCrumb";
import { useDispatch, useSelector } from "react-redux";
import {
  SupportRequestList,
  UpdateSupportRequestStatus,
} from "../../Redux/Actions/OrganizationAction";
import { Pagination, Stack, Tooltip } from "@mui/material";
import {
  capitalizeFirstLetter,
} from "../../utils/Helper";
import {
  formatDate,
  calculateTotalPages,
} from "../../utils/Helper";
import MessageContainer from "./SupportHelper/MessageContainer";
import Spinner from "../DefaultComponent/Spinner";
import ToggleButton from "@mui/material/ToggleButton";
import SelectOption from "../DefaultComponent/FilterHelper/SelectOption";
import SearchInput from "../DefaultComponent/FilterHelper/SelectInput";
import { StyledToggleButtonGroup } from "../DefaultComponent/FilterHelper/Tooglebutton";
import { requestFilter } from "../../utils/Json";
import ToastDefault from "../DefaultComponent/Toast";

const SupportRequest = () => {
  const dispatch = useDispatch<any>();
  const [count, setcount]: any = useState(0);
  const [loading, setLoading]: any = useState(false);
  const [RequestList, setRequestList] = useState([]);
  const [detailData, setDetailData] = useState({});
  let SupportRequestListData = useSelector(
    (state: any) => state.SupportRequestListData
  );
  let SupportRequestStatus = useSelector(
    (state: any) => state.UpdateSupportRequestStatus
  );
  const [page, setPage] = useState(1);
  const [rowsPerPage] = useState(12);
  const [isSetting, setIsSetting] = useState<boolean>();
  const [alignment, setAlignment] = React.useState("all");
  const [select, setSelect] = useState<string>("Search By");
  const [search, setSearch] = useState<string>("");

  const fetchQueiresData = (params: any) => {
    setLoading(true);
    dispatch(SupportRequestList(params));
    setLoading(false);
  };
  useEffect(() => {
    const params = `?page=${page}&page_size=${rowsPerPage}${
      select !== "Search By" && search.trim() !== ""
        ? `&${select}=${search}`
        : ""
    }`;
    fetchQueiresData(params);
  }, [dispatch, page, rowsPerPage, search, select]);

  useEffect(() => {
    if (SupportRequestListData?.data?.row) {
      setRequestList(() => SupportRequestListData?.data?.row);
      setcount(() => SupportRequestListData?.data?.total_count);
    }
  }, [SupportRequestListData]);

  const handleStatusChange = (payload: any) => {
    setLoading(true);
    dispatch(UpdateSupportRequestStatus(payload));
  };

  useEffect(() => {
    if (SupportRequestStatus?.data || SupportRequestStatus?.loading === false) {
      const params = `?page=${page}&page_size=${rowsPerPage}`;
      fetchQueiresData(params);
    }
  }, [SupportRequestStatus, dispatch, page, rowsPerPage]);

  const openSetting = (id: any, data: any) => {
    if (id) {
      setIsSetting(true);
      let param = ``;
      setDetailData(data);
    }
  };

  const handleChange = (
    event: React.MouseEvent<HTMLElement>,
    newAlignment: string
  ) => {
    setAlignment(newAlignment);
    let params;
    if (newAlignment == "all") {
      params = `?page=${page}&page_size=${rowsPerPage}`;
    } else {
      params = `?page=${page}&page_size=${rowsPerPage}&status=${newAlignment}`;
    }

    fetchQueiresData(params);
  };

  return (
    <>
      {loading && <Spinner />}
      <div
        className="page-wrapper card"
        style={{ display: "flex", flexDirection: "column" }}
      >
        <div className="col-md-12">
          <Breadcrumb
            pageTitle="Organizations"
            breadcrumbs={[
              {
                label: "HelpnSupport",
                path: "/support_requests/queries",
                isActive: false,
              },
              {
                label: "Queries",
                path: "/support_requests/queries",
                isActive: true,
              },
            ]}
          />
        </div>

        <div className="row  m-2 mt-4 mb-0">
          <div className="col-md-12 filter-bar">
            <div className="d-flex justify-content-between">
              <div className="col-md-2 status-option">
                <StyledToggleButtonGroup
                  color="primary"
                  value={alignment}
                  exclusive
                  onChange={handleChange}
                  aria-label="Platform"
                >
                  <ToggleButton value="all">All</ToggleButton>
                  <ToggleButton value="pending">Pending</ToggleButton>
                  <ToggleButton value="active">Active</ToggleButton>
                  <ToggleButton value="resolved">Resolved</ToggleButton>
                </StyledToggleButtonGroup>
              </div>

              <div className="col-md-6 search-bar">
                <SelectOption
                  option={requestFilter}
                  select={select}
                  setPage={setPage}
                  setSelect={setSelect}
                />
                <SearchInput
                  placeholder={`Search`}
                  setPage={setPage}
                  searchText={search}
                  setSearchText={setSearch}
                />
              </div>
            </div>
          </div>
        </div>

        <div
          className="row"
          style={{ width: "100%", display: "flex", flexWrap: "nowrap" }}
        >
          {/* Table */}
          <div
            className={`m-2 ${
              isSetting ? "table-container" : "table-full-container"
            }`}
            style={{ flex: isSetting ? 3 : 1 }}
          >
            <div className="card">
              <div className="table-responsive">
                <table className="table">
                  <thead className="table-dark">
                    <tr>
                      <th scope="col">S.No</th>
                      <th scope="col">Email</th>
                      <th scope="col">Reported By</th>
                      <th scope="col">Status</th>
                      <th scope="col">Created At</th>
                      <th scope="col">Respond</th>
                    </tr>
                  </thead>
                  <tbody>
                    {RequestList?.length > 0
                      ? RequestList.map(
                          (requestList: any, requestListkey: any) => (
                            <Fragment key={requestListkey}>
                              <tr>
                                <th scope="row">
                                  {(page - 1) * rowsPerPage +
                                    requestListkey +
                                    1}
                                </th>
                                <td>{requestList?.email}</td>
                                <td>{requestList?.fullname}</td>
                                <td>
                                  <div
                                    style={
                                      requestList?.status === "resolved"
                                        ? {
                                            color: "green",
                                            backgroundColor: "#d9e9d9",
                                          }
                                        : requestList?.status === "active"
                                        ? {
                                            color: "orange",
                                            backgroundColor: "#ebe7e0",
                                          }
                                        : {
                                            color: "blue",
                                            backgroundColor: "#d4e3e8",
                                          }
                                    }
                                    className="rounded-pill status-item"
                                  >
                                    <span className="me-2">
                                      <i className="fa-solid fa-circle fa-2xs"></i>
                                    </span>
                                    <span>
                                      {capitalizeFirstLetter(
                                        requestList?.status
                                      )}
                                    </span>
                                  </div>
                                </td>
                                <td>{formatDate(requestList?.modified_at)}</td>
                                <td>
                                  <button
                                    style={{ border: "none" }}
                                    type="button"
                                    onClick={() =>
                                      openSetting(requestList?.id, requestList)
                                    }
                                  >
                                    <i className="fa-solid fa-ellipsis fa-xl"></i>
                                  </button>
                                </td>
                              </tr>
                            </Fragment>
                          )
                        )
                      : ""}
                  </tbody>
                </table>
              </div>
            </div>

            <div className="pagination-style">
              <Stack spacing={2}>
                <Pagination
                  count={calculateTotalPages(count, rowsPerPage)}
                  color="primary"
                  variant="outlined"
                  shape="rounded"
                  page={page}
                  onChange={(e: any, newPage) => setPage(newPage)}
                />
              </Stack>
            </div>
          </div>

          {/* MessageContainer */}
          {isSetting && (
            <div className="message-container mt-2" style={{ flex: 1 }}>
              <MessageContainer
                setIsSetting={setIsSetting}
                data={detailData}
                title={"Queries Details"}
                onSubmit={handleStatusChange}
              />
            </div>
          )}
        </div>
      </div>

      <ToastDefault />
    </>
  );
};

export default SupportRequest;
